import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { setLegalAnswerById, checkLegalQuestionValidation, resetSecondaryLegalQuestionByPrimaryId } from '../../../actions/salesActions';
import { AdminJudgementQuestion } from '../../../interfaces/Legal/legalInterfaces';
import SecondaryLegalSection from './SecondaryLegalSection'
import ReactTooltip from "react-tooltip";

class LegalSection extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            questionAnswer: undefined,
        }
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick(e: any) {
        let answer = e.target.value;
        this.setState({
            questionAnswer: answer === '1'
        })
        await this.props.dispatchSetLegalAnswerById(this.props.question.id, answer === '1')
        await this.props.dispatchCheckLegalQuestionValidation();
        if(!(answer === '1'))
        {
            await this.props.dispatchResetSecondaryLegalQuestionByPrimaryId(this.props.question.id)
        }
    }

    public render() {
        let questionItem: AdminJudgementQuestion = this.props.question as AdminJudgementQuestion;
        let secondaryQuestions = questionItem.secondaryAdminJudgementQuestions.map((item) => {
            return <SecondaryLegalSection question={item} />
        });
        return (
            <div className="col-12 nopa" id={questionItem.id}>
                <div className="row noma legalsection-parent-row">
                    <div className="col nopa">
                        <div className="row noma">
                            <div className="judgement-question-col judgement-question-holder nopa">
                                <p className="admin-judgement-question">{questionItem.text}</p>
                            </div>
                            <div className="completionTooltip-col ml-10px text-right text-lg-left nopa">
                                <img className="raftooltip" id="quostionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for={questionItem.id} data-tip="" />
                                <ReactTooltip id={questionItem.id} className="rafreacttool" place="right" effect="solid" backgroundColor="#3a1826" delayShow={1000} >{questionItem.tooltipText}</ReactTooltip>
                            </div>
                        </div>
                    </div>
                    <div className="nopa text-lg-right legal-section-button-col">
                        <div className="row noma">
                            <div className="col nopa">
                                <button className={(!this.state.questionAnswer && this.state.questionAnswer !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnNo' value='0' onClick={this.handleClick}>No</button>
                            </div>
                            <div className="legal-section-mobile-gutter nopa"></div>
                            <div className="col nopa">
                                <button className={this.state.questionAnswer ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} value='1' id='btnYes' onClick={this.handleClick}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.questionAnswer && secondaryQuestions}
                <hr className="mb-18px mt-19px legalsection-hr-2px" />
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchCheckLegalQuestionValidation: () => dispatch(checkLegalQuestionValidation()),
        dispatchSetLegalAnswerById: (questionId, answerBool) => dispatch(setLegalAnswerById(questionId, "", answerBool, 0)),
        dispatchResetSecondaryLegalQuestionByPrimaryId: (questionId,) => dispatch(resetSecondaryLegalQuestionByPrimaryId(questionId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LegalSection);